import React, { Component, ErrorInfo } from 'react';

interface Props {
  children: React.ReactNode;
  onError?: (error: Error, errorInfo: ErrorInfo) => void;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class VoiceRecordingErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
    };
  }

  static getDerivedStateFromError(error: Error): State {
    return {
      hasError: true,
      error,
    };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('VoiceRecording Error:', error, errorInfo);
    this.props.onError?.(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg p-3">
          Voice recording encountered an error. Please refresh the page and try again.
          <br />
          <span className="text-xs text-red-500">Error: {this.state.error?.message}</span>
        </div>
      );
    }

    return this.props.children;
  }
}
